import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"
import CircleIcon from "@mui/icons-material/Circle"

/**
 * Questo componente una card mostrata sopra la mappa. 
 * Mostra e spiega i vari status che possono avere le piante mostrate sulla mappa.
 * @returns una Card informativa
 */
export default function LegendCard() {
  return (
    <Card
      variant="outlined"
      sx={{
        m: 1,
        p: 1,
        width: "150px",
        backgroundColor: "background.tertiary",
        borderRadius: "10px",
      }}
    >
      <CardContent>
        <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
          Stato di salute
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row", // ensures horizontal layout
            alignItems: "center", // vertical centering
            gap: 1, // space between icon and text
            mb: 1, // margin bottom between rows
          }}
        >
          <CircleIcon fontSize="small" sx={{ color: "green" }} />
          <Typography variant="body2">Ottimo</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row", // ensures horizontal layout
            alignItems: "center", // vertical centering
            gap: 1, // space between icon and text
            mb: 1, // margin bottom between rows
          }}
        >
          <CircleIcon fontSize="small" sx={{ color: "orange" }} />
          <Typography variant="body2">Discreto</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row", // ensures horizontal layout
            alignItems: "center", // vertical centering
            gap: 1, // space between icon and text
            mb: 1, // margin bottom between rows
          }}
        >
          <CircleIcon fontSize="small" sx={{ color: "red" }} />
          <Typography variant="body2">Critico</Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
